import { render, staticRenderFns } from "./InputSelectCountry.vue?vue&type=template&id=4856279d"
import script from "./InputSelectCountry.vue?vue&type=script&lang=ts"
export * from "./InputSelectCountry.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports